'use client';

import { SplitWizardProvider } from '../../model/split-wizard-context';
import { SplitWizardSubmitProvider } from '../../model/split-wizard-submit-context';
import type { SplitWizardStep } from '../../model/split-wizard-state';
import { useStartRegistration } from '@/features/auth-signup-start';
import { StartStepSwitch } from './start-step-switch';


const STEP_ORDER: SplitWizardStep[] = [ 'email', 'profile' ];


export const StartWizard = () => {
    const submitValue = useStartRegistration();

    return (
        <SplitWizardProvider
            initialStep="email"
            stepOrder={ STEP_ORDER }
        >
            <SplitWizardSubmitProvider value={ submitValue }>
                <div data-template="start-wizard">
                    <StartStepSwitch/>
                </div>
            </SplitWizardSubmitProvider>
        </SplitWizardProvider>
    );
};
